import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class LinkShareModalService {
  constructor(private httpClient: HttpClient) {}

  get(eventId: number): Observable<ILinkShare> {
    return this.httpClient.get<ILinkShare>(
      `/index.php/link-share/get?eventId=${eventId}`
    );
  }

  save(eventId: number, password?: string): Observable<ILinkShare> {
    // Send the password as form data
    const fd = new FormData();
    if (password) {
      fd.append('password', password);
    }

    return this.httpClient.post<ILinkShare>(
      `/index.php/link-share/create?eventId=${eventId}`,
      fd
    );
  }

  delete(eventId: number): Observable<void> {
    return this.httpClient.delete<void>(
      `/index.php/link-share/delete?eventId=${eventId}`
    );
  }
}

export interface ILinkShare {
  link: string;
  password: string;
}
